// extracted by mini-css-extract-plugin
export default {"noBetsTextContainer":"styles_noBetsTextContainer__5Xc1K","titleRow":"styles_titleRow__l3iQB"};